import type {CustomFieldView} from '../blocks-and-design/content-blocks/types';

import {getCustomFieldListEmptyStateMessage} from './helpers';

import styles from './custom-field-list-empty-state.module.css';

type Props = {
    view: CustomFieldView;
};

export function CustomFieldListEmptyState(props: Props) {
    return (
        <p className={styles['empty-state']}>
            <i>{getCustomFieldListEmptyStateMessage(props.view)}</i>
        </p>
    );
}
